// ============================================================
// DAILY INTERVAL MATCHER
// ============================================================
//
// Determines whether a given calendar date is an occurrence
// of a Daily recurrence.
//
// BluPrint recurrence interval is stored in:
//     template.interval_value
//
// Example:
//
// start = 2026-08-04
// interval = 3
//
// occurrences:
//     8/4
//     8/7
//     8/10
//     8/13
//     ...
//
// IMPORTANT:
// Date-only database values such as YYYY-MM-DD must be treated
// as LOCAL calendar dates, not UTC dates.
// ============================================================

export function matchesDailyInterval({
    template,
    operationalDate
}) {

    // --------------------------------------------------------
    // Interval
    // --------------------------------------------------------

    const interval =
        Number(template.interval_value) || 1

    // --------------------------------------------------------
    // Convert a date-only database value into a local
    // calendar date.
    // --------------------------------------------------------

    function toLocalCalendarDate(value) {

        if (!value) {
            return null
        }

        if (value instanceof Date) {

            return new Date(
                value.getFullYear(),
                value.getMonth(),
                value.getDate()
            )
        }

        if (
            typeof value === 'string' &&
            /^\d{4}-\d{2}-\d{2}$/.test(value)
        ) {

            const [
                year,
                month,
                day
            ] = value.split('-').map(Number)

            return new Date(
                year,
                month - 1,
                day
            )
        }

        const parsed =
            new Date(value)

        return new Date(
            parsed.getFullYear(),
            parsed.getMonth(),
            parsed.getDate()
        )
    }

    // --------------------------------------------------------
    // Recurrence start date
    // --------------------------------------------------------

    const startCalendar =
        toLocalCalendarDate(
            template.recurrence_start_date
        )

    if (!startCalendar) {
        return false
    }

    // --------------------------------------------------------
    // Operational date
    // --------------------------------------------------------

    const todayCalendar =
        toLocalCalendarDate(
            operationalDate
        )

    if (!todayCalendar) {
        return false
    }

    // --------------------------------------------------------
    // Calculate whole calendar days elapsed.
    // --------------------------------------------------------

    const millisecondsPerDay =
        24 * 60 * 60 * 1000

    const daysElapsed =
        Math.round(
            (
                todayCalendar.getTime() -
                startCalendar.getTime()
            ) /
            millisecondsPerDay
        )

    // --------------------------------------------------------
    // Before recurrence start
    // --------------------------------------------------------

    if (daysElapsed < 0) {
        return false
    }

    // --------------------------------------------------------
    // Does this date land on the interval?
    // --------------------------------------------------------

    return daysElapsed % interval === 0
}